import { createSlice } from "@reduxjs/toolkit";
import { SupplierResponseDto } from "../../shared/dtos/supplier/SupplierResponseDto";
import { SupplierSummaryDto } from "../../shared/dtos/supplier/SupplierSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const supplierSlice = createSlice({
  name: "supplier",
  initialState: getInitialCrudState<SupplierResponseDto, SupplierSummaryDto>(),
  reducers: {
    ...generateCrudReducers<SupplierResponseDto, SupplierSummaryDto>(),
  },
});

export const supplierActions = supplierSlice.actions;
export default supplierSlice.reducer;
